// import queryString from 'query-string';
import _send, { sendAsFormData as _sendAsFormData } from 'Src/shared/send';
import config from 'Config';
const path = require('path');

const send = (...args) => {
  if (config.env === 'development') {
    return Promise.resolve();
  }
  return _send(...args);
};
const sendAsFormData = (...args) => {
  if (config.env === 'development') {
    return Promise.resolve();
  }
  return _sendAsFormData(...args);
};

const reservationURL = (...sections) => {
  return path.join(config.path.api, 'reservations', ...sections);
};

/**
 * 予約情報 サーバー入力確認
 * @param  {Object} params 予約情報
 * @return {Promise}        送信結果Promise
 */
const validateReservation = (params) => {
  const url = reservationURL('validation');
  const method = 'POST';
  const body = params;
  return sendAsFormData(url, { method, body });
};

/**
 * 予約情報 新規登録
 * @param  {Object} params 予約情報
 * @return {Promise}        送信結果Promise
 */
const createReservation = (params) => {
  const method = 'POST';
  const url = reservationURL();
  const body = params;
  return sendAsFormData(url, { method, body });
};

/**
 * 予約情報 認証
 * @param  {Object} params 予約認証情報
 * @return {Promise}        送信結果Promise
 */
const certificateReservation = (params) => {
  if (config.env === 'development') {
    const dummy = { reservationCode: '1234-567890', token: 'token' };
    return Promise.resolve(dummy);
  }
  const method = 'POST';
  const url = reservationURL(params.reservationCode, 'certificate');
  const body = params;
  return sendAsFormData(url, { method, body });
};

import dummyConfig from 'Src/config/develop';

/**
 * 予約情報取得
 * @param  {Object} params 送信パラメータ
 * @param  {Object} params.reservationCode 予約番号
 * @param  {Object} params.token 認証APIで取得した認証トークン
 * @return {Promise}        送信結果Promise
 */
const getReservation = (params) => {
  if (config.env === 'development') {
    const dummy = dummyConfig.closeInitialData;
    return Promise.resolve(dummy);
  }
  const method = 'GET';
  const url = `${reservationURL(params.reservationCode)}.json`;
  const headers = { Token: params.token };
  return send(url, { headers, method });
};

/**
 * 予約情報 変更
 * @param  {Object} params 予約情報
 * @return {Promise}        送信結果Promise
 */
const changeReservation = (params) => {
  const method = 'POST';
  const url = reservationURL(params.reservationCode);
  const headers = { Token: params.token };
  const body = params;
  return sendAsFormData(url, { headers, method, body });
};

/**
 * 予約情報 取消（論理削除）
 * @param  {Object} params 予約情報
 * @param  {Object} params.reservationCode 予約番号
 * @param  {Object} params.token 認証APIで取得した認証トークン
 * @return {Promise}        送信結果Promise
 */
const deleteReservation = (params) => {
  const method = 'DELETE';
  const url = reservationURL(params.reservationCode);
  const headers = { Token: params.token };
  return sendAsFormData(url, { headers, method });
};

export default {
  validateReservation,
  createReservation,
  certificateReservation,
  getReservation,
  changeReservation,
  deleteReservation
};
